import cookie from 'react-cookie';
import userLegacySettings from '../utils/user/settings';

export const getUserDetails = (state) => {
  const userDetails = state.user.details;
  const warningType = state.user.warningType;
  const data = {
    ...userDetails,
    warningType,
  };
  if (data) {
    return data;
  }
  return null;
};

export const getUserSettings = (state) => {
  const data = state.user.settings;
  if (data) {
    return data;
  }
  return null;
};

export const getUserBwWindWaveModel = (state) => {
  if (!state.user.details) {
    const bwWindWaveModel = cookie.load('bw_wind_wave_model');
    if (bwWindWaveModel) return bwWindWaveModel;
  }
  if (!state.user.settings) return 'LOLA';
  const data = state.user.settings.bwWindWaveModel || 'LOLA';
  if (data) {
    return data;
  }
  return null;
};

export const getUserLocation = (state) => {
  const data = state.user.location;
  if (data) {
    return data;
  }
  return null;
};

export const getUserEntitlements = (state) => {
  const data = state.user.entitlements;
  if (data) {
    return data;
  }
  return null;
};

export const getUserLegacyEntitlements = (state) => {
  const data = state.user.legacyEntitlements;
  if (data) {
    return data;
  }
  return null;
};

export const getUserFavorites = (state) => {
  const data = state.user.favorites;
  if (data) {
    return data;
  }
  return null;
};

export const getUserLegacySettings = (state) => {
  const userDetails = getUserDetails(state);
  const userLocation = getUserLocation(state);
  const userSettings = getUserSettings(state);
  const userLegacyEntitlements = getUserLegacyEntitlements(state);
  const userFavorites = getUserFavorites(state);
  return userLegacySettings(
    userDetails,
    userLocation,
    userSettings,
    userLegacyEntitlements,
    userFavorites,
  );
};

export const getBasicStatus = state => state.user.entitlements.includes('bw_basic');
export const getPremiumStatus = state => state.user.entitlements.includes('bw_premium');



// WEBPACK FOOTER //
// ./src/selectors/user.js